<template>
    <!-- 对话框 -->
    <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto">
                    <el-form-item label="优惠名称:" label-width="150px">
                        <el-input v-model="submit_data.title" :placeholder="submit_rules.title.placeholder" style="width: 80%"> </el-input>
                    </el-form-item>

                    <el-form-item label="状态:" label-width="150px">
                        <el-select
                            v-model="value_status_code"
                            placeholder="请选择状态"
                            style="width: 150px; margin-right: 20px"
                            @change="statusChange"
                            clearable
                        >
                            <el-option label="启用" value="1"></el-option>
                            <el-option label="禁用" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="参与用户:" label-width="150px">
                        <el-select
                            v-model="value_type_code"
                            placeholder="请选择参与用户"
                            style="width: 150px; margin-right: 20px"
                            @change="typeChange"
                            clearable
                        >
                            <el-option label="不限" value="0"></el-option>
                            <el-option label="新司机" value="1"></el-option>
                            <el-option label="老司机" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                     <el-form-item label="签约类型:" label-width="150px">
                        <el-select
                            v-model="submit_data.job_type"
                            placeholder="请选择签约类型"
                            style="width: 150px; margin-right: 20px"
                  
                            clearable
                        >
                    
                            <el-option label="全职" value="1"></el-option>
                            <el-option label="兼职" value="2"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="优惠条件:" label-width="150px">
                        <el-input v-model="submit_data.full_month" :placeholder="submit_rules.full_month.placeholder" style="width: 80%">
                        </el-input
                        >个月
                    </el-form-item>

                    <el-form-item label="优惠后金额（元）:" label-width="150px">
                        <el-input v-model="submit_data.amount" :placeholder="submit_rules.amount.placeholder" style="width: 80%"> </el-input
                        >
                    </el-form-item>
                </el-form>

                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center">
                    <el-button type="primary" @click="onSubmit">保存</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this
                .$post('/driver/getSigningMonthPreferentialDetails', {
                    driver_signing_month_preferential_code: _this.data
                })
                .then((res) => {
                    _this.submit_data.driver_signing_month_preferential_code = res.data.driver_signing_month_preferential_code;
                    _this.submit_data.title = res.data.title;
                    _this.submit_data.full_month = res.data.full_month;
                    _this.submit_data.amount = res.data.amount;
                    _this.submit_data.status = res.data.status.val;
                    _this.submit_data.type = res.data.type.val;
                    _this.submit_data.job_type = res.data.job_type;
                    _this.value_status_code = res.data.status.alias;
                    _this.value_type_code = res.data.type.alias;
                })
                .catch((res) => {});
                
        }
    },
    data() {
        return {
            show: false,

            value_status_code: '',
            value_type_code: '',
            

            // 表单数据
            submit_data: {
                driver_signing_month_preferential_code: '',
                title: '',
                full_month: 0,
                amount: 0,
                status: '',
                type: '',
                job_type: ''
            },

            submit_rules: {
                title: {
                    placeholder: '优惠名称',
                    rules: {
                        required: true,
                        message: '优惠名称长度3-10个文字以内',
                        regulation: 'between_str',
                        rulesData: [3, 10]
                    }
                },
                full_month: {
                    placeholder: '优惠条件',
                    rules: {
                        required: true,
                        message: '优惠条件（月）不能小于0',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                amount: {
                    placeholder: '优惠后金额（元）',
                    rules: {
                        required: true,
                        message: '优惠后金额（元）不能小于0',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                status: {
                    placeholder: '状态',
                    rules: {
                        required: true,
                        message: '状态',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                type: {
                    placeholder: '参与用户',
                    rules: {
                        required: true,
                        message: '参与用户',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                  job_type: {
                    placeholder: '签约类型',
                    rules: {
                        required: true,
                        message: '签约类型',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
       
        statusChange(val) {
            console.log(val,'statusChange---statusChange---val');
           
           _this.submit_data.status = val;
            console.log(_this.submit_data.status,'_this.submit_data.status');

        },
        typeChange(val) {
            console.log(val,'typeChange---val');
            _this.submit_data.type = val;
            console.log(_this.submit_data.status,'typeChange---_this.submit_data.status');
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.submit_data = {
                driver_signing_month_preferential_code: '',
                title: '',
                full_month: 0,
                amount: 0,
                status: '',
                type: '',
                job_type: ''
            };
            _this.value_status_code = '';
            _this.value_type_code = '';
        },
        // 提交
        onSubmit() {
            console.log(_this.submit_data);

            _this
                .$post('/driver/editSigningMonthPreferentialSubmit', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    // 触发父组件自定义事件刷新表格
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                    this.$message.success(res.msg);
                })
                .catch((res) => {});
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
</style>